import React, { useState, useEffect, useContext, useRef } from 'react';
import { MetricsFilterTitle } from '../styles/containerComponents.styles';
import answerValues from '../data/answers'
import styled, {css} from 'styled-components'
import { fontSizeS, colorOrange, colorTeal, colorPurple } from '../styles/sharedStyles';
import {ChartContext} from '../context/ChartContext'
import Tooltip from './Tooltip';
import _ from 'lodash'

const Container = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
    align-self: stretch;
    margin-bottom: 1rem;
    

    font-size: ${fontSizeS};
`

const AnswerList = styled.div`
    display: flex;
    flex-direction: column;
`

const Answer = styled.div`
    display: flex;
    justify-content: space-between;

    cursor: pointer;
    border-radius: 3px;
    margin-bottom: .5rem;
    padding: .5rem 1rem;
    position: relative;

    color: ${props => props.inArray ? `${colorOrange}` : `#fff`};
    background-color: ${props => props.inArray ? `#fff` : props.color};

    .delete-icon {
        visibility: hidden;
    }

    ${props => !props.filterable 
    ? css`
        &:hover{
            background-color: ${props => props.inArray ? '#fff' : `${colorOrange}`};
            color: ${props => props.inArray ? props.color : `#fff`};
        }
        &:hover > .delete-icon {
            visibility: visible;
        } 
    `
    : css`
        cursor: auto;
        &:hover > .delete-icon {
            visibility: visible;
            color: ${props => props.color};
        } 
    `}
` 

const DeleteSpan = () => <span className="delete-icon">&#10005;</span>
const AddSpan = () => <span className="delete-icon">&#10003;</span>

const FilterList = () => {

    const [ questionAnswers, setQuestionAnswers ] = useState([])
    const [ filterable, setFilterable ] = useState(true)
    const [ mousePosition, setMousePosition ] = useState([0,0])
    const { filteredAnswers, setFilteredAnswers, filterQuestions,
            metricQuestions, setFiltersQuestions, setMetricQuestions,
            futureFilteredAnswer, setFutureFiltereAnswer, 
            expectedCountryTotals, countryTotals, path } = useContext(ChartContext)
    const tooltipRef = useRef()
    useEffect(() => {
        const newAnswers = filterQuestions.map(el => answerValues[+el.qid] )
        setQuestionAnswers(newAnswers)
    }, [filterQuestions])

    const isFilterableValue = (
        questionAnswers, i, el
    ) => {
        const allAnswers = questionAnswers[i].answers
        const isFilterable = (allAnswers.length - filteredAnswers.filter(d => d.question === el.question).length) > 1
        return isFilterable
    }

    const handleFilterTitleClick = q => {
        const newFilterQuestions = filterQuestions.filter(d => d.question !== q.question)
        const newMetricQuestions =  _.uniqBy([...metricQuestions, q].sort((a,b) => +a.qid - +b.qid), "qid")
        const newFilteredAnswers = filteredAnswers.filter(a => a.qid !== q.qid)
        setFilteredAnswers(newFilteredAnswers)
        setFiltersQuestions(newFilterQuestions)
        setMetricQuestions(newMetricQuestions)
    }

    const nextTotal = _.sumBy(expectedCountryTotals, d => d.total)
    const currTotal = _.sumBy(countryTotals, d => d.total)

    const getStatus = (el, answer) => filteredAnswers.filter(d => d.question === el.question).map(d => d.answer).includes(answer)
    
    const TiltleMapping = filterQuestions.map((el, i) => (
        <Container key={i}>
            <MetricsFilterTitle
                onClick={() => handleFilterTitleClick(el)}
            >
                {el.question}
                <span className="delete-icon">&#10005;</span>
            </MetricsFilterTitle>
            <AnswerList>
                {questionAnswers[i] && questionAnswers[i].answers.map((answer, index) => 
                        <Answer 
                            key={answer}
                            color={path === "hrds" ? colorTeal : colorPurple}
                            onMouseMove={(e) => {

                                if(!isFilterableValue(questionAnswers, i, el)){
                                    setFilterable(false)
                                } else if (
                                    !filterable && isFilterableValue(questionAnswers, i, el)
                                ){  
                                    setFilterable(true)
                                }
                            }}
                            onMouseOver={() => {
                                if(futureFilteredAnswer.length === 0){
                                    setFutureFiltereAnswer([{ qid: el.qid, question: el.question, answer: answer }])
                                } else if (
                                    futureFilteredAnswer[0].answer !== answer
                                ){
                                    setFutureFiltereAnswer([{ qid: el.qid, question: el.question, answer: answer }])
                                }
                                setMousePosition([1, -30])
                            }}
                            onMouseOut={() => setMousePosition([0, 0])}
                            onClick={() => {
                                const filteredAnswersArray = filteredAnswers.filter(d => d.question === el.question).map(d => d.answer)
                                if(filteredAnswersArray.includes(answer)){
                                    const otherQuestions = filteredAnswers.filter(d => d.question !== el.question)
                                    setFilteredAnswers([...otherQuestions, ...filteredAnswers
                                                                                .filter(d => d.question === el.question)
                                                                                .filter(d => d.answer !== answer)])
                                } else if (
                                    !filteredAnswersArray.includes(answer)  && isFilterableValue(questionAnswers, i, el)
                                ) { 
                                    setFilteredAnswers([...filteredAnswers, { qid: el.qid, question: el.question, answer: answer }])
                                }
                            }}
                            inArray={filteredAnswers
                                        .filter(d => d.question === el.question)
                                        .map(d => d.answer)
                                        .includes(answer)}
                            filterable={!filterable && !filteredAnswers
                                                            .filter(d => d.question === el.question)
                                                            .map(d => d.answer)
                                                            .includes(answer)}
                        >   
                            {answer}
                                {
                                    getStatus(el, answer) 
                                        ?  <AddSpan/>
                                        : <DeleteSpan/>
                                }
                            <Tooltip
                                ref={tooltipRef}
                                position="bottom"
                                top={mousePosition[1]}
                                left={mousePosition[0]}
                                visible={mousePosition.includes(0) ? false : true  
                                            && futureFilteredAnswer[0].answer === answer
                                            && el.question === futureFilteredAnswer[0].question
                                            &&  nextTotal > 0 }
                            >
                                Number of respondents if filtered {getStatus(el, answer) ? "in" : "out"}: {nextTotal} 
                                &nbsp;({getStatus(el, answer) ? "+" : "-"}{getStatus(el, answer) ? nextTotal - currTotal : currTotal - nextTotal})
                            </Tooltip>
                        </Answer>
                )}
            </AnswerList>
        </Container>
    
   ))

    return ( 
        <>
            {TiltleMapping}
        </>
     );
}
 
export default FilterList;